import { Tab, Tabs, Badge, useTheme, useMediaQuery } from "@mui/material";
import {
    HomeOutlined,
    PersonOutline,
    StickyNote2Outlined,
    TrackChangesOutlined,
    DescriptionOutlined,
    FactCheckOutlined
} from '@mui/icons-material';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import {colors, borders} from "./ui/colors";

const ClientTabs = ({ hasNotes, hasCheckIns, setTabValue, tabValue }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const tabsData = [
        { value: "one", label: "ראשי", icon: <HomeOutlined />, hasAlert: false },
        { value: "two", label: "פרופיל", icon: <PersonOutline />, hasAlert: false },
        { value: "three", label: "מטרות", icon: <TrackChangesOutlined />, hasAlert: false },
        { value: "four", label: "טפסים", icon: <DescriptionOutlined />, hasAlert: false },
        { value: "five", label: "פתקים", icon: hasNotes ? <FmdBadIcon /> : <StickyNote2Outlined />, hasAlert: hasNotes },
        { value: "six", label: "צ'ק-אין", icon: <FactCheckOutlined />, hasAlert: hasCheckIns },
    ];

    const getTabStyles = (hasAlert = false) => ({
        minHeight: "48px",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "1.2",
        color: hasAlert ? colors.error : colors.neutral,
        textTransform: "none",
        padding: { xs: "6px 10px", md: "8px 12px" },
        transition: "all 0.2s ease-in-out",
        "&.Mui-selected": {
            color: hasAlert ? colors.error : colors.primary,
            fontWeight: 700,
            backgroundColor: colors.primarySubtle
        },
        "&:hover": {
            backgroundColor: colors.primarySubtle,
            color: hasAlert ? colors.error : colors.primary
        },
        "& .MuiTab-iconWrapper": {
            marginBottom: { xs: "2px", md: "3px" },
            fontSize: { xs: "16px", md: "18px" },
            color: "inherit"
        }
    });

    return (
        <Tabs
            variant="fullWidth"
            value={tabValue}
            onChange={handleChange}
            sx={{
                marginTop: { xs: 0, md: "12px" },
                borderBottom: borders.default,
                backgroundColor: colors.white,
                direction: "rtl",
                "& .MuiTabs-indicator": {
                    height: "2px",
                    borderRadius: "2px 2px 0 0",
                    backgroundColor: colors.primary,
                    background: `linear-gradient(90deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`
                },
                "& .MuiTabs-flexContainer": {
                    gap: { xs: 0, md: "4px" },
                    direction: "rtl"
                },
                "& .MuiTab-root": {
                    borderRadius: { xs: 0, md: "8px 8px 0 0" },
                    margin: { xs: 0, md: "0 2px" }
                }
            }}
        >
            {tabsData.map((tab) => (
                <Tab
                    key={tab.value}
                    value={tab.value}
                    sx={getTabStyles(tab.hasAlert)}
                    icon={
                        tab.hasAlert ? (
                            <Badge
                                color="error"
                                variant="dot"
                                sx={{
                                    "& .MuiBadge-dot": {
                                        width: "8px", height: "8px", borderRadius: "50%",
                                        backgroundColor: colors.error,
                                        border: `2px solid ${colors.white}`
                                    }
                                }}
                            >
                                {tab.icon}
                            </Badge>
                        ) : tab.icon
                    }
                    iconPosition="top"
                    label={tab.label}
                    wrapped={isMobile}
                />
            ))}
        </Tabs>
    );
};

export default ClientTabs;
